module.exports = width => {
  if (width < 600) return "mobile";
  else return "pc";
};
